import { createFileRoute } from '@tanstack/react-router';

import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { ContactForm } from './-components/detail/ContactForm';

/**
 * Full-form contact creation. The list page also offers a faster two-step
 * modal (open via /contacts?new=1) for the common case; this route stays as
 * the deep-linkable "all fields available" entry point that the modal links to.
 */
function NewContactRoute() {
  useSetBreadcrumbs([
    { label: 'Contacts', to: '/contacts' },
    { label: 'New contact' },
  ]);
  return <ContactForm />;
}

export const Route = createFileRoute('/contacts/new')({
  component: NewContactRoute,
});
